import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

function MentionsLegale() {
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

    const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef<HTMLElement>(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const {t} = useTranslation() as {t:(key: string)=>string}
  return (
     <div>
        <button onClick={handleClickOpen('paper')}>{t("Mentions légales")}</button>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description">

                <DialogTitle id="scroll-dialog-title" className='text-xl font-semibold text-orange-500' >{t("Mentions légales")}</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                                                
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}>
                        <div className="w-full h-full">
                                <p className="text-justify text-gray-700">
                                    Les présentes CGU ont pour objet de définir les conditions dans lesquelles les utilisateurs 
                                    accèdent aux services de réservation de voyages, séjours, vols, hébergements, transports et 
                                    autres prestations touristiques proposés par l’agence.
                                </p>
                                <p className="text-justify text-gray-700">
                                    Toute utilisation des services de l’agence, qu’elle soit effectuée en ligne, 
                                    par téléphone ou en agence, implique l’acceptation sans réserve des présentes CGU.
                                    Si vous n’acceptez pas ces conditions, vous ne devez pas utiliser les services proposés.
                                </p>

                                <div className="text-gray-700 mt-4">
                                    <h3 className="text-lg font-semibold">L’agence propose notamment les services suivants:</h3>
                                    <ul className="list-disc pl-5 mt-2 w-full">
                                    <li className="w-full">Réservation de voyages</li>
                                    <li className="w-full">Réservation de séjours</li>
                                    <li className="w-full">Réservation de vols</li>
                                    <li className="w-full">Réservation d’hébergements</li>
                                    <li className="w-full">Réservation de transports</li>
                                    <li className="w-full">Autres prestations touristiques</li>
                                    </ul>
                                </div>

                                <div className="text-gray-700 mt-4">
                                    <h3 className="text-lg font-semibold">INSCRIPTION ET DONNÉES PERSONNELLES:</h3>
                                    <p>
                                         L’utilisateur peut être amené à fournir certaines informations personnelles lors de la réservation. Il s’engage à fournir des informations exactes, complètes et à jour.
                                         Les données collectées sont traitées conformément à notre Politique de confidentialité, disponible sur le site.
                                    </p>
                                </div>

                                <p className="text-justify text-gray-700 mt-4">
                                    {t("En acceptant cette politique, vous consentez à la collecte et à l'utilisation de vos informations conformément à nos pratiques décrites.")}
                                </p>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className='transform active:scale-75 transition-transform' style={{backgroundColor:"#233D4D", color:"white"}} onClick={handleClose}>{t("Retour")}</Button>
                    <Button className='transform active:scale-75 transition-transform' style={{border:"2px solid #233D4D", color:"#233D4D"}} onClick={handleClose}>{t("Accepter")}</Button>
                </DialogActions>
            </Dialog>
    </div>
  )
}

export default MentionsLegale